// PURE DATA + loader arrows. No lazy(), no side effects (see ../types.ts contract).
import type { ModuleManifest } from '../types';
import { blogSlug } from '../paths';

export const blogModule: ModuleManifest = {
  id: 'blog',
  routes: [
    { path: `/${blogSlug}/:slug`, load: () => import('../../pages/BlogPost') },
  ],
  menuItems: [{ title: import.meta.env.VITE_BLOG_NAME || 'Blog', path: `/${blogSlug}` }],
};
